// src/pages/portal/ClientPortalLayout.jsx

import React from "react";
import { Outlet } from "react-router-dom";
import {
  Box,
  Container,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme } from "@mui/material/styles";
import ClientPortalSidebar from "./ClientPortalSidebar";

export default function ClientPortalLayout() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleToggleSidebar = () => {
    setMobileOpen((prev) => !prev);
  };

  const handleCloseSidebar = () => {
    setMobileOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: "#f3f4f6",
      }}
    >
      {/* Desktop sidebar */}
      {isDesktop && (
        <Box
          sx={{
            width: 260,
            flexShrink: 0,
            borderRight: "1px solid #e5e7eb",
            bgcolor: "white",
          }}
        >
          <ClientPortalSidebar />
        </Box>
      )}

      {/* Mobile top bar + drawer */}
      {!isDesktop && (
        <>
          <AppBar
            position="fixed"
            elevation={0}
            sx={{
              bgcolor: "white",
              color: "#111827",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <Toolbar
              sx={{
                minHeight: 56,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <IconButton
                edge="start"
                onClick={handleToggleSidebar}
                sx={{ mr: 1 }}
                aria-label="Open navigation"
              >
                <MenuIcon />
              </IconButton>
              <Typography
                variant="h6"
                noWrap
                sx={{ fontSize: 16, fontWeight: 600 }}
              >
                Client Portal
              </Typography>
            </Toolbar>
          </AppBar>

          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleCloseSidebar}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": {
                width: 260,
                boxSizing: "border-box",
              },
            }}
          >
            <ClientPortalSidebar onNavigate={handleCloseSidebar} />
          </Drawer>
        </>
      )}

      {/* Main content area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          bgcolor: "#f3f4f6",
          pt: isDesktop ? 0 : "56px",
        }}
      >
        <Container maxWidth="lg" sx={{ py: { xs: 2, md: 3 } }}>
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
}